var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnthropicAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M13.62 8.71 7.9 23.29h3.02l1.18-3.07h5.92l1.18 3.07h3.02L16.48 8.71h-2.86Zm-.57 8.97 2-5.16 2 5.16h-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M21.47 9.02h2.82L30 23.29h-2.98L21.47 9.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M25.28 24.53c-2.52 1.41-5.6 2.13-9.17 2.13-4.18 0-7.93-1.08-11.23-3.25-.27-.18-.08-.52.22-.39 3.5 1.48 7.05 2.22 10.66 2.22 3.17 0 6.22-.57 9.15-1.72.44-.17.79.53.37 1.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M25.77 22.59c.66-.08 1.55-.06 1.75.21.21.28-.1 1.1-.39 1.72-.11.23-.33.2-.28-.04.11-.54.23-1.21.08-1.37-.14-.16-.8-.11-1.33-.04-.28.04-.31-.42.17-.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnthropicAws);
export default __webpack_public_path__ + "static/media/AnthropicAWS.a9ec40c9bc197eb0d1ae46e88e8c9bdd.svg";
export { ForwardRef as ReactComponent };